import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from '../../../tableSettings';
import {
  DateRenderer,DateTimeRenderer, FloatRenderer, TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import PrimaryButton from '../../../ui/PrimaryButton';
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import periodCloseIcon from '../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../img/periodclose-12.svg';
import opCloseIcon from '../../../img/OPClose.svg';
import opCloseIcon2 from '../../../img/opclose-12.svg';
import accountCloseIcon from '../../../img/AccountClose.svg';
import accountCloseIcon2 from '../../../img/accountingclose-12.svg';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {Search} from '../../../filtering';
import {JobNames} from '../../../framework.core/JobNames';
import {airExportHawbList} from '../tableSettings';
import {AeHblListItem} from '../../../fms.data/models/AeHblListItem';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import {useHistory} from 'react-router';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import ApplicationContext from '../../../ApplicationContext';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import loadInfoAreaInvoiceBillCrDb from '../../common/InfoAreaInvoiceBillCrDb';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import fastStorage from '../../../fastStorage';
import HawbBlStatusPopup from './HawbBlStatusPopup';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import { FmsSubMenu } from '../../../constants/fmsSubMenu';
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from '../../../hooks/useReportViewer';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, ShipmentTypeRenderer } from '../../common/commonListRenderers';
import { getFmsGlobal } from '../../../globals';
import * as XCol from '../../../framework.core/XExportColumn';
import postal from 'postal';
import useSetEditedId from '../../../hooks/useSetEditedId';
import Select from '../../../ui/Select';
import { FmsSecTask } from '../../../fms.core/constants';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, findSecurityTaskWithBranch, getSecBySecTask, isEawbEnabled } from '../../../util';
import { EawbEdiStatusText, FreightStatusText } from '../../../fms.core/pims/Eawb';
import EawbHistoryPopup from '../eawb/implementation/EawbHistoryDialog';
import { useJournal } from '../../accounting/general/journal/JournalListView';
import PrimaryInverseButton from '../../../ui/PrimaryInverseButton';
import _ from 'lodash';
import RecogModal from '../../../ui/RecogModal';
import constants from '../../../constants';
import { formatAEBlType, formatShipmentType } from '../../common/utils/formatUtils';
import { Decimalformat } from '../../common/commonExportFormat';
import { BillingsIconButton, DeleteHistoryIconButton, DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, RecogHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../ui/IconButton';
import { SecType } from '../../../fms.enum';
import JobSwitchingMenuContext from '../../jobSwitchingMenuContext';
import useJobMenus from '../../../hooks/useJobMenus';
import taskReminderIconRed from '../../../img/pin_red.svg';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';
  else if (lStatus === 'AC') dataTooltip = 'Accounting Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }
  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="12px" src={opCloseIcon2} id={'blueIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;
  else if (lStatus === 'AC')
    content = <img height="12px" src={accountCloseIcon2} id={'blackIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt=""/>;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function BlTypeRenderer({cell}:any) {
  let value = '';

  if (cell.value === 'D') {
    value = 'Regular';
  } else if (cell.value === 'C') {
    value = 'Consol';
  } else if (cell.value === 'L') {
    value = 'Co-Load';
  }

  return (
    <div className="ifms-table-default" data-cell-actual-value={cell.value}>{value}</div>
  );
}

// e-AWB FWB/FHL 상태 코드 → 표시 문구 (EAwbStatus.cs Collection 대응, BlTypeRenderer 패턴).
// 3.3 ListRenderer 와 동일하게 마우스오버 시 "FWB Accepted" 식 툴팁, 클릭 시 e-AWB 이력 팝업
// (HAWB 행도 3.3 처럼 소속 MAWB 기준 이력을 연다).
function EawbStatusRenderer({ cell, data, row }: any) {
  const [historyOpen, setHistoryOpen] = useState(false);
  // 빈값(미전송)은 공백으로 표시
  const text = cell.value ? (EawbEdiStatusText[cell.value] ?? cell.value) : '';
  const dataTooltip = cell.value ? `${(cell.column?.id === 'fhl') ? 'FHL' : 'FWB'} ${text}` : '';
  const mawbNo = data[row.index]?.mawbNo ?? '';
  return (
    <>
      {/* 팝업을 클릭 div 의 형제로 렌더 — 자식으로 두면 팝업 내부 클릭이 React 트리로 버블되어 다시 열린다 */}
      <div className="ifms-table-default" data-cell-actual-value={cell.value} data-tooltip={dataTooltip}
        style={{ cursor: 'pointer' }} onClick={() => setHistoryOpen(true)}>{text}</div>
      {historyOpen && <EawbHistoryPopup mawbNo={mawbNo} onClose={() => setHistoryOpen(false)} />}
    </>
  );
}

// FRT Status(F_Fsu) — 코드는 그대로 표시하고 툴팁으로 설명(3.3 FreightStatusCode.Collection), 클릭 시 이력 팝업.
function FrtStatusRenderer({ cell, data, row }: any) {
  const [historyOpen, setHistoryOpen] = useState(false);
  const dataTooltip = FreightStatusText[cell.value ?? ''] ?? '';
  const mawbNo = data[row.index]?.mawbNo ?? '';
  return (
    <>
      <div className="ifms-table-default" data-cell-actual-value={cell.value} data-tooltip={dataTooltip}
        style={{ cursor: 'pointer' }} onClick={() => setHistoryOpen(true)}>{cell.value}</div>
      {historyOpen && <EawbHistoryPopup mawbNo={mawbNo} onClose={() => setHistoryOpen(false)} />}
    </>
  );
}

function BlTypeFilterRenderer({value, onChange}:any) {
  return (
    <Select
      name='ifms-filter-blType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        // { label: '', value: '' },
        { label: 'Regular', value: 'D' },
        { label: 'Consol', value: 'C' },
        { label: 'Co-Load', value: 'L' },
      ]}      
    />
  );
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHawbOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

function MemoDetailRenderer({value, data, row}: any) {
  const {openDocServer} = useSelectedHawbOperation();

  const memoCnt = value;

  if(memoCnt === '0'){
    return <div className="ifms-table-default">{value}</div>;
  }

  return <div onClick={() => openDocServer(data[row.index])} style={{width: '100%', color: 'blue', fontWeight: 'bold', lineHeight:'1em', cursor:'pointer'}}>{value}</div>
}

function RefNoRenderer({value, data, row, cell}: any){
    
  const isPending = data[row.index].taskPendingCnt > 0;

    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">
      {value}{isPending ? <img style={{marginBottom:'1px', marginLeft:'3px'}}width='11px' height='11px' src={taskReminderIconRed} />: <></>}
    </div>
}

function AgentRenderer({ cell, value, data, row }: any) {
  const agentCnt  = (data[row.index].agentCnt - 1);

  return ( 
    <div id={`${cell.column.id}-${row.index}`} className="ifms-table-align-left">{value}{agentCnt > 0 ? ' + ' + agentCnt : ''}</div>
  );
}

function useHawbOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  function switchToMawbFor(hawb: AeHblListItem | null) {
    if (!hawb) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/aeMawb/airExport', 
    'id', 'Ref. #', hawb.aeMblId, 'u2Date', false, true, null, 'refNo', hawb.refNo, false,true);
    openNewPage(history, `/common/joblistview/aeMawb/airExport`, NavigationType.newPage);
  }

  async function switchToAcctInfo(hawb:AeHblListItem|null) {
    if (!hawb) {
      return;
    }

    let link = `/accounting/Acct/${JobNames.AEHbl}/${hawb.id}`;

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(link, [link]);
  }

  return {switchToMawbFor, switchToAcctInfo};
}

function useSelectedHawbOperation() {
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const context = useContext(JobSwitchingMenuContext);
  const {removeSingleJobMenuinTab} = useJobMenus();
  const { switchToMawbFor } = useHawbOperations();

  const selectedElement = jobListContext.selectedElement as AeHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');

  const setSavedEntityAem = useSetEditedId([JobNames.AEMbl]);

  function openDocServer(mbl:AeHblListItem|null){
    if (!mbl) {
      return;
    }

    if(appContext.appInfoAreaContent === 'none') appContext.setAppInfoAreaContent('memo'); 
  }


  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/airExport/hawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/aeMawb/airExport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/airExport/mawb/edit/' + jobListContext.f6Query;

    const newUrl = openedByF6 || openedByMaster
      ? `/airExport/hawb/add?mawbRefId=${jobListContext.f6Query}`
      : '/airExport/hawb/add';

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }

    // if (
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/edit/${selectedElement.id}`) || 
    //   jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${selectedElement.id}`)
    // ) {
    //   await showGlobalOkDialog('Need to close HAWB first', false, null, "warning");
    //   return;
    // }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/hawb/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/hawb/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.',false,null,'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.AEHbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      if (apiResult && apiResult.success) {
        // List에서 데이터를 Delete할 때 해당 데이터가 View/Edit 모드로 Open 되어있으면 그 탭을 Close하도록 동작
        const editUrl = `/airExport/hawb/edit/${selectedElement.id}`;
        const viewUrl = `/airExport/hawb/view/${selectedElement.id}`;
        if (jobListContext.hasOpenedScreenStartingWithUrl(editUrl) || jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
            context.resetForCurrentJob();
            removeSingleJobMenuinTab(jobListContext.hasOpenedScreenStartingWithUrl(editUrl) ? editUrl : viewUrl, '');
        }
        jobListContext.reloadData();
        setSavedEntityAem(selectedElement.aeMblId?.toString(), false);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');  
      }
    }
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl =`/airExport/hawb/edit/${id}`;
    const viewUrl = `/airExport/hawb/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/airExport/hawb/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 4;
    const baseUrl = '/airExport/hawb';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);

    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.AEHbl}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  // 기본적으로 View Mode로 동작하고 Edit 화면이 열려있는 경우 Edit 화면으로 이동.
  async function viewProfit() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const tabIndex = 6;
    const baseUrl = '/airExport/hawb';
    const editBaseUrl = `${baseUrl}/edit/${id}`;
    const viewBaseUrl = `${baseUrl}/view/${id}`;

    const isEditOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(editBaseUrl);
    const isViewOpen = jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(viewBaseUrl);
    
    // View의 TabIndex 설정
    if (isEditOpen || isViewOpen) {
      const modeStr = isEditOpen ? 'edit' : 'view';
      fastStorage[`${modeStr}${JobNames.AEHbl}TabIndexRequest${id}`] = tabIndex;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(
      `${viewBaseUrl}/${tabIndex}`, [viewBaseUrl, editBaseUrl]);
  }

  async function moveToDeleteHistoryReport() {
   const listSec = findSecurityTask(appContext, FmsSecTask.AEDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AEHbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToRecogHistoryReport() {
   const listSec = findSecurityTask(appContext, FmsSecTask.AERecogHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/recogHistory?jobname=${JobNames.AEHbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/airExport/hawb/view/${id}`;
    const editUrl = `/airExport/hawb/edit/${id}`;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEHbl, selectedElement.branch);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);

  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/airExport/hawb/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/airExport/hawb/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMawb() {
    const selectedElement = jobListContext.selectedElement as AeHblListItem;
    switchToMawbFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, setSavedEntityAem, openDocServer };
}


function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMawb, recognize, viewBillings, viewProfit } = useSelectedHawbOperation();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AeHblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEHbl, selectedElement?.branch);
  const mawbSec = findSecurityTask(appContext, FmsSecTask.AEMbl);
  const fmsGlobal = getFmsGlobal();
  const userID = appContext.user ? appContext.user.id ?? '' : '';

  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.AEHbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false, null,'warning');
      return;
    }


     const hasOpenedMbl =
    jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/edit/${selectedElement.id}`) ||
    jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${selectedElement.id}`)

    if (selectedElement.isClosed && hasOpenedMbl) {
      const editModelKey = `editAeHawb${selectedElement.id}-/airExport/hawb/edit`;
      const viewModelKey = `viewAeHawb${selectedElement.id}-/airExport/hawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].isFileClosed = false;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 0;
        fastStorage[viewKeyMatch].isFileClosed = false;
        fastStorage[viewKeyMatch].closedBy = '';
        fastStorage[viewKeyMatch].closeDate = null;
      }
    }else if (!selectedElement.isClosed && hasOpenedMbl) {
       const editModelKey = `editAeHawb${selectedElement.id}-/airExport/hawb/edit`;
      const viewModelKey =  `viewAeHawb${selectedElement.id}-/airExport/hawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const closeDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_AOHMAIN',
        fieldName: 'F_CloseDate'
      });

      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 1;
        fastStorage[keyMatch].isClosed = true;
        fastStorage[keyMatch].closedBy = userID;
        fastStorage[keyMatch].closeDate = closeDate;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].fileClosed = 1;
        fastStorage[viewKeyMatch].isClosed = true;
        fastStorage[viewKeyMatch].closedBy = userID;
        fastStorage[viewKeyMatch].closeDate = closeDate;
      }

    }

    
    jobListContext.reloadData();
  }

  async function processAccountLock() {
    const accountLockResult = await appContext.api.accountClose(JobNames.AEHbl, selectedElement.id, !selectedElement.isAccountClosed);
    if (!!accountLockResult) {
      await showGlobalOkDialog(accountLockResult, false, null,'warning');
      return;
    }

    const hasOpenedMbl =
      jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/edit/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${selectedElement.id}`)

    if (selectedElement.isAccountClosed && hasOpenedMbl) {
      const editModelKey = `editAeHawb${selectedElement.id}-/airExport/hawb/edit`;
      const viewModelKey = `viewAeHawb${selectedElement.id}-/airExport/hawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 0;
        fastStorage[keyMatch].isAccountClosed = false;
        fastStorage[keyMatch].accountClosedBy = '';
        fastStorage[keyMatch].accountCloseDate = null;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 0;
        fastStorage[viewKeyMatch].isAccountClosed = false;
        fastStorage[viewKeyMatch].accountClosedBy = '';
        fastStorage[viewKeyMatch].accountCloseDate = null;
      }
    }else if (!selectedElement.isAccountClosed && hasOpenedMbl) {
      const editModelKey = `editAeHawb${selectedElement.id}-/airExport/hawb/edit`;
      const viewModelKey = `viewAeHawb${selectedElement.id}-/airExport/hawb/view`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      const viewKeyMatch = _.keys(fastStorage).find(x => x.startsWith(viewModelKey));
      const accountCloseDate = await appContext.api.getFieldValueDate({
        id: selectedElement.id,
        tableName: 'T_AOHMAIN',
        fieldName: 'F_AcctCloseDate'
      });


      if (keyMatch) {
        fastStorage[keyMatch].accountClosed = 1;
        fastStorage[keyMatch].isAccountClosed = true;
        fastStorage[keyMatch].accountClosedBy = userID;
        fastStorage[keyMatch].accountCloseDate = accountCloseDate;
      }
      if (viewKeyMatch) {
        fastStorage[viewKeyMatch].accountClosed = 1;
        fastStorage[viewKeyMatch].isAccountClosed = true;
        fastStorage[viewKeyMatch].accountClosedBy = userID;
        fastStorage[viewKeyMatch].accountCloseDate = accountCloseDate;
      }
    }
    
    jobListContext.reloadData();
  }

  let showFileLock = (!selectedElement?.isClosed ? getFmsGlobal().CanFileLock : getFmsGlobal().CanFileUnlock) && listSec?.grantEdit;
  let showAccountLock = (!selectedElement?.isAccountClosed ? getFmsGlobal().CanAccountLock : getFmsGlobal().CanAccountUnlock) && listSec?.grantEdit;
  // const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.confirmDate??'') < (getFmsGlobal().CloseDate??'');
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to MAWB List', shortcut: 'F6', separator: false, hidden: !mawbSec?.grantRead },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: noBillingsShow && noProfitShow, hidden: !listSec?.grantAdd },
    { label: 'Billings', shortcut: 'F7', separator: noProfitShow, hidden: noBillingsShow },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: listSec?.grantEdit ?? false, hidden: noProfitShow },
    // { label: 'View B/L Activity Status', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    { label: !selectedElement?.isAccountClosed ? 'Accounting Close' : 'Accounting Open', shortcut: '', separator: false, hidden: !showAccountLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !getFmsGlobal().CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !getFmsGlobal().CanFinalize || !listSec?.grantEdit },
  ];

  const itemStatus = [
    { label: !selectedElement?.isClosed ? 'File Lock' : 'Unlock', shortcut: '', separator: false, hidden: !showFileLock },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="aeh-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        switchToMawb();
        break;
      case 6:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 7:
        copy();
        break;
      case 8:
        viewBillings();
        break;
      case 9:
        viewProfit();
        break;
      case 10:
        processFileLock();
        break;
      case 11:
        processAccountLock();
        break;
      case 12:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function HawbListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AeHblListItem;
  const history = useHistory();
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEHbl, selectedElement?.branch);
  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = !(fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = !(fmsGlobal.NoProfitShow ?? false);  

  const { copy, create, edit, view, switchToMawb, viewBillings, viewProfit } = useSelectedHawbOperation();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  const mawbSec = findSecurityTask(appContext, FmsSecTask.AEMbl);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      if (mawbSec.grantRead)
        switchToMawb();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    }  else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
    } else if (unprocessedFkey === "F7") {
      if (noBillingsShow)
        viewBillings();
    }else if (unprocessedFkey === "CTRL+F7") {
      if (noProfitShow)
        viewProfit();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `HAWB #: ${(jobListContext.selectedElement as AeHblListItem|null)?.hawbNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.AEHbl}
      jobId={(jobListContext.selectedElement as AeHblListItem|null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

function HawbListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  return null;
}

function HawbListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  const selectedElement = jobListContext.selectedElement as AeHblListItem;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);
  const { deleteHbl, edit, view, copy, viewBillings, viewProfit, moveToDeleteHistoryReport, moveToRecogHistoryReport, setSavedEntityAem } = useSelectedHawbOperation();

  // function hasOpenedViewOrEditFor(id:number) {
  //   return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/mawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${id}`);
  // }
  
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const {switchJournal} = useJournal();


  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/add`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityAem(selectedElement.aeMblId?.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onAesFilingPimsClick = (vanningId: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    let source = 'codetest;hykim@ssikor.co.kr;123qwe;2370762'; //for Test
    let key = 'DevPower EnCrypt by Steve Robbins';
    let utf8Encode = new TextEncoder();
    let k = 0;
    let keyChar = utf8Encode.encode(key);
    let result = "";
    let inputChar = utf8Encode.encode(source);

    for(var i = 0;i<inputChar.length;i++){
        result += (inputChar[i] ^ keyChar[k++]).toString(16).toUpperCase().padStart(2, '0');
        if (k >= keyChar.length) k = 0;
    }

    result = (inputChar.length * 2).toString().padStart(6, '0') + result;
    
    window.open('https://aes.suntekscm.com/home/loginrequest/' + result);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.AEHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/airExport/hawb/view/${id}`);
  }

  const allowedStatuses = ['', 'E', 'D'];

  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEHbl, selectedElement?.branch);
  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalOP, SecType.Read) && !userId.startsWith('@');

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;

  const fmsGlobal = getFmsGlobal();
  const noBillingsShow = (fmsGlobal.NoBillingsShow ?? false);
  const noProfitShow = (fmsGlobal.NoProfitShow ?? false);  

  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/aeMawb/airExport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/airExport/mawb/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
      ? `/airExport/hawb/add?mawbRefId=${jobListContext.f6Query}`
      : '/airExport/hawb/add';

  //const tbName = getTbNameByJobName(JobNames.AEHbl);

  return (
    <div className="ifms-common-no-vertical-separator-gap-margin">
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='aeh-list-add-button' display="primary" link={newUrl} disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='aeh-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='aeh-list-view-button' disabled={!hasSelectedRow} onClick={view} useText/>
        <DeleteIconButton2 name='aeh-list-delete-button' disabled={!canBeDeleted} onClick={deleteHbl} useText/>
      </div>
      <div className='ifms-common-vertical-gap-8'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <PrimaryButton name='aeh-list-copy-button' disabled={!canBeCopied} onClick={copy} size={'extrasmall'}>Copy/Paste</PrimaryButton>
      {!noBillingsShow && <BillingsIconButton name='aeh-list-billings-button' data-tooltip={constants.List_Billings} onClick={viewBillings} useText/>}
      {!noProfitShow && <PrimaryButton name='aeh-list-profit-button' onClick={viewProfit} size="extrasmall" >Profit</PrimaryButton>}
      <DeleteHistoryIconButton onClick={moveToDeleteHistoryReport} useText/>
      <RecogHistoryIconButton onClick={moveToRecogHistoryReport} useText/>
      {!checkSecJournal && <JournalIconButton onClick={() =>switchJournal(JobNames.AEHbl, selectedElement.id, "", null, selectedElement.hawbNo)} useText/>}
      </div>
      {/*<div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <ActionButton
          variant="plain"
          onItemSelected={(event) => setSelectedPopupMenuItem(event)}
          type="primary"
          items={[
            { label: 'Correction Notice/Request', separator: false, popupComponent: <CorrectionNotice jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Pickup/Delivery Instruction', separator: false, popupComponent: <PickupDelivery jobName={JobNames.AEHbl} docType={DocumentType.Pickup} selectedElementId={selectedElement?.id} /> },
            { label: 'Print HAWB', separator: true, popupComponent: <Print jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Est. Profit', separator: true, newCol: true,subMenu: FmsSubMenu.HouseProfit },
            //{ label: 'Go to Carrier\'s Tracking', separator: true, newCol: true, link: 'http://dotnet.freightstream.com/fsutil/customs.asp?mbn=' + selectedElement?.mawbNo },

            { label: 'Air Label', separator: false, popupComponent: <AirLabel docType={DocumentType.LabelAir} jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Bank Draft', separator: false, popupComponent: <BankDraft jobName={JobNames.AEHbl} selectedElement={selectedElement} /> },
            { label: 'Certificate of Origin', separator: false, popupComponent: <CertificateOfOrigin jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Document Package', separator: false, popupComponent: <DocumentPackage jobName={JobNames.AEHbl} selectedElement={selectedElement} /> },
            { label: 'Commercial Invoice', separator: false, popupComponent: <CommercialInvoice selectedElementId={selectedElement?.id} jobName={JobNames.RptCommercialInvoice} tbName={tbName} /> },
            { label: 'Memo List', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.AEHbl} />, popupLabel: 'Memo List (HAWB)' },
            { label: 'Memo List (Customer)', separator: false, popupComponent: <MemoList selectedElement={selectedElement} jobName={JobNames.Company} />, popupLabel: 'Memo List (Customer)' },
            { label: 'Package Label', separator: false, popupComponent: <PackageLabel jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> },
            { label: 'Packing List', separator: false, popupComponent: <CommercialInvoice selectedElementId={selectedElement?.id} jobName={JobNames.RptPackingList} tbName={tbName} /> },
            { label: 'Shipping Advice', separator: false, popupComponent: <ShippingAdvice jobName={JobNames.AEHbl} selectedElement={selectedElement} /> },
            { label: 'Straight B/L', separator: true, popupComponent: <StraightBl jobName={JobNames.AEHbl} selectedElementId={selectedElement?.id} /> }

            { label: 'Denied Party (BIS)', separator: false },
            { label: 'Denied Party (OFAC)', separator: false },
            { label: 'Denied Party (ITAR)', separator: false },
          ]}
        >
          More Menu
        </ActionButton>
        
        <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
          onClick={() => setSelectedPopupMenuItem({ label: 'Go to Carrier\'s Tracking', link: `http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mawbNo}` })}>
          <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
        </BlackInverseButton>
      </div> */}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.aeMblId} mTbName={"T_AOMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function formatData(data:Array<AeHblListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

function AfterMemoLogButtonCommands() {
  return null;
}

/**
 * Concrete implementation for AE HAWB List screen
 *
 * @class MawbListView
 * @extends {AbstractListView}
 */
 class HawbListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings = airExportHawbList;
    const useBranch = systemSettings?.enableBranch ?? false;
    const enableEawb = isEawbEnabled(suntekSettings);
    const cols = AeHblListItem.getExportCollection(useBranch, enableEawb);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }
  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u1Date',
      orderByAscending: false,
    };
  }
  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      // {
      //   accessor: 'recognized',
      //   renderer: RecognizedFilterRenderer,
      //   searchValueExtractor: (v:any|null|undefined) => v,
      // },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'blType',
        renderer: BlTypeFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'invStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'billStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'crDbStat',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }
  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const enableEawb = isEawbEnabled(suntekSettings);   // FWB/FHL/FRT Status 컬럼도 렌더러(중앙정렬 등)를 받도록 getTableSettings 와 동일하게 전달
    return AeHblListItem.getExportCollection(useBranch, enableEawb).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if(x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      // else if (x.dataIndex === 'recognized') {
      //     colRenderer.Cell = RecognizedRenderer;
      // }
      else if(x.dataIndex === 'memoCnt') { colRenderer.Cell = MemoDetailRenderer;}
      else if(x.dataIndex === 'refNo') {colRenderer.Cell = RefNoRenderer;}
      else if (x.dataIndex === 'paidStat') colRenderer.Cell = PaidRenderer;
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if(x.dataIndex === 'agentName') colRenderer.Cell = AgentRenderer;
      else if (x.dataIndex === 'shipper' || x.dataIndex === 'cName' || x.dataIndex === 'nName') colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs' || x.dataIndex === 'lbs'|| x.dataIndex === 'chgLbs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if (x.dataIndex === 'kgs' || x.dataIndex === 'chgKgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={1} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      else if(x.dataIndex === "blType") colRenderer.Cell = BlTypeRenderer;
      else if (x.dataIndex === 'fwb' || x.dataIndex === 'fhl') colRenderer.Cell = EawbStatusRenderer;
      else if (x.dataIndex === 'fsu') colRenderer.Cell = FrtStatusRenderer;
      return colRenderer;
    });
  }
    
   getExportRenderers(): ExportRowRenderer[] {
     const colRenderer = [];
     colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
     colRenderer.push({ accessor: 'shipmentType', changedValue: (value: any) => { return formatShipmentType(value['shipmentType']) } });
     colRenderer.push({ accessor: 'pkgs', changedValue: (value: any) => { return value['pkgs'] } });
     colRenderer.push({ accessor: 'lbs', changedValue: (value: any) => { return value['lbs'] } });
     colRenderer.push({ accessor: 'chgLbs', changedValue: (value: any) => { return value['chgLbs'] } });
     colRenderer.push({ accessor: 'kgs', changedValue: (value: any) => { return Decimalformat(value['kgs'],1) } });
     colRenderer.push({ accessor: 'chgKgs', changedValue: (value: any) => { return Decimalformat(value['chgKgs'],1) } });
     colRenderer.push({ accessor: 'blType', changedValue: (value: any) => { return formatAEBlType(value['blType']) } });
     return colRenderer;
   }

  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number, opType: string): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AEHbl,
      'AeHblListItem',
      AeHblListItem.calculateSearchParameters(search, AeHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
      );

      if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
        return {data: [], totalCount: 0};
      }
  
      return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AEHbl, 'AeHblListItem',
      AeHblListItem.calculateSearchParameters(search, AeHblListItem.MapSearchFields, ['shipmentType', 'invStat', 'billStat', 'crDbStat']),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }


  renderCommands(): React.ReactNode {
    return (
      <HawbListCommands />
    );
  }
  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <HawbListToolbar />
    );
  }
  renderAfterConfigureButton(): React.ReactNode {
    return <></>
  }
  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return <HawbListViewExtras hideLogHistory={hideLogHistory} />
  }
  getViewUrlFor(row: any): string {
    return row && row.id ? `/airExport/hawb/view/${row.id}` : '';
  }
  getListViewTitle(): string {
    return 'HAWB List';
  }
   renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any, appContext: any): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

    const selectedElement = context.selectedElement as AeHblListItem;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AEHbl, selectedElement.branch);

    function onClose() {
      const storageKey = `ae-hawb-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    const hblElement = (context.data ?? []).find( x => x.id === rowId);

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="B/L Status" width="760px">
        <HawbBlStatusPopup
          hawbNo={hblElement?.hawbNo ?? ''}
          departure={hblElement?.lCode ?? ''}
          arrival={hblElement?.dCode ?? ''}
          eta={hblElement?.eta}
          etd={hblElement?.etd}
          hawbId={rowId}
          storageKey={`ae-hawb-milestone-${rowId}`}
          onClose={onClose}
          isView={!listSec?.grantEdit}
        />
      </IfmsModal>
    );
  }
  
  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.AEHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false}/>;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  commandsAfterFilterBtn():React.ReactNode{
    return <AfterMemoLogButtonCommands />
  }
  
  useLogHistory(): boolean {
    return true;
  }
}

export default HawbListView;
